module.exports = __webpack_public_path__ + "static/media/CC-COL10_1xnca96C8jvKv6yqECRYlnRZxh3iyEddN.70294d19.bin";


//////////////////
// WEBPACK FOOTER
// ./src/assets/thumbs/CC-COL10_1xnca96C8jvKv6yqECRYlnRZxh3iyEddN
// module id = 768
// module chunks = 0